import styles from "./main.module.scss";
import { ReactComponent as Logo } from "../../svgs/logo.svg";
import { ReactComponent as Arrow } from "../../svgs/arrow-back.svg";
import { Link, useLocation } from "react-router-dom";

interface AuthLayoutProps {
  children?: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const location = useLocation();
  return (
    <div className={styles.layout}>
      <main className={styles.container}>
        <Logo className={styles.logo} />
        {children}
        {location.pathname === "/" ? null : (
          <Link className={styles.link} to="/">
            <span>
              <Arrow />
            </span>
            Back to Login
          </Link>
        )}
      </main>
    </div>
  );
};

export default AuthLayout;

